import OpenOrderSearch from "@dana/Components/OpenOrderDetails/OpenOrderSearch";
import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import GetOpenOrdersData from "@dana/Store/Data/OpenOrders/Handlers/GetOpenOrdersHandler";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface OpenOrdersPageStyles {
    page?: MobiusPageProps;
    outerGridContainer?: GridContainerProps;
    innerGridContainer?: GridContainerProps;
    outerGridItem?: GridItemProps;
    innerGridItem?: GridItemProps;
    wrapper?: InjectableCss;
}

export const openOrdersPageStyles: OpenOrdersPageStyles = {
    page: {
        background: themeBackgrounds.offWhite,
        fullWidth: [true, true, true, true, true],

        css: css`
            [data-test-selector="PageTitle"] {
                margin-bottom: 0;
                padding-left: 5px;
            }
        `,
    },
    outerGridContainer: {
        gap: 0,
    },
    innerGridContainer: {
        gap: 0,

        offsetCss: css`
            gap: 16px;
        `
    },
    outerGridItem: {
        width: 12,
        css: css`
            [class*="Wrapper"] {
                [data-test-selector="PageTitle"] {
                    padding-left: 0;
                }
            }
        `
    },
    innerGridItem: {
        width: 12,
    },
    wrapper: {
        css: css`
            width: 100%;
            padding: 0 16px 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 0 24px 32px;
                        `,
                        css`
                            padding: 0 40px 80px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
};
const mapStateToProps = (state: ApplicationStateDana) => ({
    session: getSession(state),
    openOrdersState: state.openOrders,
});

const mapDispatchToProps = {
    GetOpenOrdersData,
};

type Props = ResolveThunks<typeof mapDispatchToProps> & PageProps & ReturnType<typeof mapStateToProps>;
const styles = openOrdersPageStyles;
const OpenOrdersPage: React.FC<Props> = ({ id, openOrdersState, GetOpenOrdersData, session }) => {
    const [isLoading, setIsLoading] = React.useState(true);
    const [originalData, setOriginalData] = React.useState(openOrdersState.data);
    React.useEffect(() => {
        if (session.isAuthenticated) {
            GetOpenOrdersData({ customerNumber: "-1" });
        } else {
            window.location.href = "/";
        }
    }, []);

    React.useEffect(() => {
        setIsLoading(openOrdersState?.isLoading);
        setOriginalData(openOrdersState.data);
    }, [openOrdersState]);
    

    return (
        <Page {...styles.page}>
	       	<>
                <GridContainer {...styles.outerGridContainer}>
                    <GridItem {...styles.outerGridItem}>
                        <StyledWrapper {...styles.wrapper}>
                            <GridContainer {...styles.innerGridContainer} className="inner-container">
                                <Zone contentId={id} zoneName="OpenOrder" />
                                <GridItem {...styles.innerGridItem}>
                                    <OpenOrderSearch openOrders={originalData}></OpenOrderSearch>
                                </GridItem>
                            </GridContainer>
                        </StyledWrapper>
                    </GridItem>
                </GridContainer>
            </>
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OpenOrdersPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;
export const OpenOrdersPageContext = "OpenOrdersPage";
